import { render, staticRenderFns } from "./o-title.vue?vue&type=template&id=06f16d38"
import script from "./o-title.js?vue&type=script&lang=js&external"
export * from "./o-title.js?vue&type=script&lang=js&external"
import style0 from "./o-title.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports